import { Injectable } from '@angular/core';
import {
  TotalCarsDto,
  TotalCars,
  RevenueSummaryDto,
  RevenueSummary,
  OccupancyDto,
  Occupancy,
  RecentTransactionDto,
  RecentTransaction,
  MonthlyStatsDto,
  MonthlyStats,
  DashboardNodeDto,
  DashboardNode,
  NodeConnectionDto,
  NodeConnection
} from '../models/dashboard-builder.model';

@Injectable({
  providedIn: 'root'
})
export class MapperDashboardBuilderService {

  // ================= Normal Functions =================

  /**
   * Maps TotalCars DTO to UI model
   * แปลงข้อมูลจำนวนรถจาก DTO เป็น UI Model
   */
  mapTotalCarsDtoToModel(dto: TotalCarsDto): TotalCars {
    return {
      activeCars: dto.active_cars,
      registeredCars: dto.registered_cars,
      percentageActive: dto.percentage_active
    };
  }

  /**
   * Maps RevenueSummary DTO to UI model
   * แปลงข้อมูลรายได้สรุปจาก DTO เป็น UI Model
   */
  mapRevenueSummaryDtoToModel(dto: RevenueSummaryDto): RevenueSummary {
    return {
      totalRevenue: dto.total_revenue,
      evRevenue: dto.ev_revenue,
      parkingRevenue: dto.parking_revenue
    };
  }

  /**
   * Maps Occupancy DTO to UI model
   * แปลงข้อมูลการเข้าจอดจาก DTO เป็น UI Model
   */
  mapOccupancyDtoToModel(dto: OccupancyDto): Occupancy {
    return {
      totalSpots: dto.total_spots,
      occupiedSpots: dto.occupied_spots,
      occupancyRate: dto.occupancy_rate
    };
  }

  /**
   * Maps RecentTransaction DTO to UI model
   * แปลงข้อมูลธุรกรรมล่าสุดจาก DTO เป็น UI Model
   */
  mapRecentTransactionDtoToModel(dto: RecentTransactionDto): RecentTransaction {
    return {
      id: dto.id,
      licensePlate: dto.license_plate,
      timeLabel: dto.timestamp,
      amount: dto.amount,
      paymentType: dto.payment_type
    };
  }

  /**
   * Maps MonthlyStats DTO to UI model
   * แปลงข้อมูลสถิติรายเดือนจาก DTO เป็น UI Model
   */
  mapMonthlyStatsDtoToModel(dto: MonthlyStatsDto): MonthlyStats {
    return {
      labels: dto.months,
      parkingCounts: dto.parking_count,
      evCounts: dto.ev_count,
      revenueData: dto.revenue_data
    };
  }

  /**
   * Maps DashboardNode Model to DTO
   * แปลงข้อมูล Node จาก Model เป็น DTO
   */
  mapDashboardNodeToDto(model: DashboardNode): DashboardNodeDto {
    return {
      id: model.id,
      type: model.type,
      title: model.title,
      x: model.x,
      y: model.y,
      data: model.data
    };
  }

  /**
   * Maps DashboardNode DTO to Model
   * แปลงข้อมูล Node จาก DTO เป็น Model
   */
  mapDashboardNodeDtoToModel(dto: DashboardNodeDto): DashboardNode {
    return {
      id: dto.id,
      type: dto.type,
      title: dto.title,
      x: dto.x,
      y: dto.y,
      isLoading: false,
      data: dto.data
    };
  }

  /**
   * Maps NodeConnection Model to DTO
   * แปลงข้อมูลจุดเชื่อมโยงจาก Model เป็น DTO
   */
  mapNodeConnectionToDto(model: NodeConnection): NodeConnectionDto {
    return {
      id: model.id,
      from_node_id: model.fromNodeId,
      to_node_id: model.toNodeId,
      from_anchor: model.fromAnchor,
      to_anchor: model.toAnchor
    };
  }

  /**
   * Maps NodeConnection DTO to Model
   * แปลงข้อมูลจุดเชื่อมโยงจาก DTO เป็น Model
   */
  mapNodeConnectionDtoToModel(dto: NodeConnectionDto): NodeConnection {
    return {
      id: dto.id,
      fromNodeId: dto.from_node_id,
      toNodeId: dto.to_node_id,
      fromAnchor: dto.from_anchor as 'left' | 'right',
      toAnchor: dto.to_anchor as 'left' | 'right'
    };
  }
}
